<template>
  <div class="content">
    <mantenimiento-item @update="inicializar"></mantenimiento-item>
    <cambiar-vehiculo @update="inicializar"></cambiar-vehiculo>
    <cambiar-avl @update="inicializar"></cambiar-avl>
    <migrar-contrato-form @update="inicializar"> </migrar-contrato-form>

    <BajaContratoModal @bajaContrato="inicializar" />

    <MantenimientoContratoModal @mantenimiento="inicializar" />

    <div class="container-fluid h-100">
      <card-item>
        <div class="d-flex justify-content-end">
          <button class="btn btn-danger btn-sm" @click="volver">Volver</button>
        </div>
      </card-item>
      <card-item>
        <template>
          <div class="d-flex justify-content-center align-items-center">
            <h4 class="card-title">Modificar contrato</h4>
          </div>
        </template>
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-4 form-group form-group-sm">
              <label class="label" for="cliente">Cliente</label>
              <input
                id="cliente"
                v-model="nombreCliente"
                :class="`form-control form-control-sm text-center bg-white`"
                disabled
                style="cursor: text"
                type="text"
              />
            </div>
            <div class="col-12 col-md-4 form-group form-group-sm">
              <label class="label" for="patente">Patente</label>
              <input
                id="patente"
                v-model="patenteAnterior"
                :class="`form-control form-control-sm text-center bg-white`"
                disabled
                style="cursor: text"
                type="text"
              />
            </div>
            <div class="col-12 col-md-4 form-group form-group-sm">
              <label class="label" for="dominio">Alias/Dominio</label>
              <input
                id="dominio"
                v-model="dominioAnterior"
                :class="`form-control form-control-sm text-center bg-white`"
                disabled
                style="cursor: text"
                type="text"
              />
            </div>
          </div>
        </div>
      </card-item>
      <card-item>
        <template>
          <div class="d-flex justify-content-center align-items-center">
            <h4 class="card-title">Seccion Administrativa</h4>
          </div>
        </template>
        <template v-if="patenteAnterior">
          <DatosContratoForm />
          <!-- <div v-else>Cargando...</div> -->
          <FacturacionForm />
          <!-- <div v-else>Cargando...</div> -->
          <AccionesContrato />
        </template>
      </card-item>
      <card-item>
        <template>
          <div class="d-flex justify-content-center align-items-center">
            <h4 class="card-title">Seccion servicio técnico</h4>
          </div>
        </template>

        <ButtonsServicioTecnico />
      </card-item>
    </div>
  </div>
</template>

<script>
import BajaContratoModal from "@/pages/Clientes/Contratos/Baja/BajaContratoModal";
import MantenimientoContratoModal from "@/pages/Clientes/Contratos/Mantenimiento/MantenimientoContratoModal";
import { get } from "lodash-es";
import axios from "axios";
import NombreCliente from "../shared/NombreCliente";
import ButtonsServicioTecnico from "./Modificar/ButtonsServicioTecnico";
import DatosContratoForm from "./Modificar/DatosContratoForm";
import FacturacionForm from "./Modificar/FacturacionForm";
import MantenimientoItem from "./Modificar/Modals/MantenimientoItem.vue";
import CambiarVehiculo from "./Modificar/Modals/CambiarVehiculo.vue";
import CambiarAvl from "./Modificar/Modals/CambiarAvl.vue";
import MigrarContratoForm from "./Modificar/Modals/MigrarContratoForm.vue";
import AccionesContrato from "./Modificar/AccionesContrato.vue";

export default {
  name: "ModificarContrato",
  mounted() {
    this.inicializar();
  },
  beforeDestroy() {
    this.$store.commit("Contratos/ModificarContrato/reset");
  },
  mixins: [NombreCliente],
  data: () => ({
    idContrato: null,
    clienteId: null,
    patenteId: null,
  }),
  components: {
    DatosContratoForm,
    ButtonsServicioTecnico,
    FacturacionForm,
    MantenimientoItem,
    CambiarVehiculo,
    CambiarAvl,
    MigrarContratoForm,
    AccionesContrato,
    BajaContratoModal,
    MantenimientoContratoModal,
  },
  methods: {
    volver() {
      this.$router.push(
        `/admin/clientes/${this.$route.params.id_cliente}/contratos`,
      );
    },
    async inicializar() {
      this.$store.commit("Contratos/ModificarContrato/reset");

      this.clienteId = this.$route.params.id_cliente;
      this.getNombreCliente(this.clienteId).then((resp) => {
        if (get(resp, "ok", true) == false) {
          this.$msgBoxOk(resp.message);
        }
        this.$store.commit(
          "Contratos/ModificarContrato/setNombreWeb",
          get(resp, "result[0][0].nombre_web", ""),
        );
      });

      this.idContrato = this.$route.params.id_contrato;
      this.getData().then((data) => {
        if (get(data, "ok", true) === false) {
          this.$msgBoxOk(data.message);
        }
      });
    },
    async getData() {
      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetContratoById",
          parameters: [
            { name: "id_contrato", value: this.$route.params.id_contrato },
          ],
        });

        if (get(resp, "data.ok", false)) {
          this.$store.commit(
            "Contratos/ModificarContrato/inicializarContrato",
            get(resp, "data.result[0][0]", {}),
          );
        }
        return resp.data;
      } catch (e) {
        console.error(e);
      }
    },
  },
  computed: {
    dominioAnterior: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.dominioAnterior;
      },
    },
    patenteAnterior: {
      get() {
        return this.$store.state.Contratos.ModificarContrato.patenteAnterior;
      },
    },
  },
};
</script>

<style scoped></style>
